import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../components/Spinner';
import SvgHeader from "../../components/SvgHeader";
import ScrollAnimation from '../../components/ScrollAnimation/ScrollAnimation';
import { constructImageUrl, isMobileDevice } from '../../utils';
import Exhibition from '../../components/Exhibition';
import { fetchCollectiveExhibitions, favouriteExhibition } from '../../services/api';
import { Title2, } from '../../components/Typography2';
import UntitledArtImg from '../../assets/images/untitled-art.png';
import FriezeArtImg from '../../assets/images/frieze-art-img.png';
import CollaborationCard from '../../components/CollaborationCard';
import { VORTIC_CURATED, FRIEZE, UNTITLED, UNTITLED_DESCRIPTION, FRIEZE_DESCRIPTION, VORTIC_CURATED_GROUP_ID } from "./const";
import SubHeader from '../../components/SubHeader';

const Collectives = (props) => {
    const { type: collaborationType } = useParams()
    const { collective: { collectives, currentPage, canLoadMore }, globalProps } = props
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [curatedExhibitions, setCuratedExhibitions] = useState([]);
    const [curatedExhibitionsLoading, setCuratedExhibitionsLoading] = useState(true);
    // @ts-ignore
    const [activeType, setActiveType] = useState(collaborationType.toLowerCase());
    const navigate = useNavigate();

    useEffect(() => {
        setActiveType(collaborationType.toLowerCase());
    }, [collaborationType])

    const fetchExhibitions = async () => {
        const curatedResp = await fetchCollectiveExhibitions(VORTIC_CURATED_GROUP_ID);
        if (curatedResp) {
            const array = curatedResp.data;
            // @ts-ignore
            array.sort((a, b) => new Date(b.data.createdAt) - new Date(a.data.createdAt));
            setCuratedExhibitions(array);
            setCuratedExhibitionsLoading(false);
        }

    }

    useEffect(() => {
        fetchExhibitions();
    }, []);

    useEffect(() => {
        setIsLoadingMore(false)
    }, [collectives.length])

    const loadData = async () => {
        if (canLoadMore && !isLoadingMore) {
            setIsLoadingMore(true)
            const nextPage = currentPage + 1
            await props.fetchCollectives(nextPage)
        }
    }

    const handleCollectiveClick = (id) => {
        navigate(`/collectives/${id}`)
    }

    const handleExhibitionClick = (id) => {
        navigate(`/exhibitions/${id}`)
    };

    const toggleExhibitionFavourite = async (exhibitionId) => {
        if (props.globalProps.isLoggedIn) {
            let resp = await favouriteExhibition(exhibitionId)
            if (resp.data) {
                if (activeType === VORTIC_CURATED) {
                    let newExhibitions = [];
                    curatedExhibitions.map(exhibition => {
                        if (exhibition.data.id === exhibitionId) {
                            exhibition = {
                                ...exhibition,
                                data: {
                                    ...exhibition.data,
                                    isFavourite: resp.data.isFavourite
                                }
                            }
                        }
                        newExhibitions.push(exhibition)
                        return exhibition;
                    })
                    setCuratedExhibitions(newExhibitions)
                }

            }
        } else {
            navigate(`/login?/collaborations/${activeType}`)
        }
    }

    useEffect(() => {
        if (window.innerWidth <= 680) {
        }
    }, [activeType])


    return (
        <div>
          
            <div className='bg-white'>
               
            </div>
        </div>
    )
}

export default Collectives
